//React
//Assets
import BackButtonDark from "assets/icons/back-dark.svg";
import BackButtonLight from "assets/icons/back-light.svg";
import HamBurgerMenuImg from "assets/icons/hamburger.svg";
import CrossImg from "assets/icons/cross.svg";
import Logo from "assets/logo.svg";
//Libraries
import cx from "classnames";
//Components
import { FlexBox, Button, Image } from "components";
import React, { useEffect, useState } from "react";
//Utils
import { ChangeHistory, EventManager, EventNames } from "utils";
//Styles
import "./styles.scss";
import { HeaderProps } from "./types";
import { setGeneralDetails } from "Slices";
import { sideMenuList, SIDE_MENU_CUSTOM_ACTIONS } from "../../../constants";
import { ROUTE_PATH } from "Routes";
import ReactGA from "react-ga4";

const Header: React.FC<HeaderProps> = ({
  className,
  pageName,
  otherDetails,
  backActionToCloseDeepLink,
  customBackAction,
  hamBurgerMenuClickCallback,
  hasLogo,
  isSideMenuOpened,
  hasSideMenu,
  hideBackButton,
}) => {
  const [menuOpened, setMenuOpened] = useState(false);
  const [hasTimerClass, setHasTimerClass] = useState(false);

  const goBack = () => {
    if (customBackAction) {
      customBackAction();
    } else {
      ChangeHistory("back");
    }
  };

  const hamBurgerMenuClicked = () => {
    hamBurgerMenuClickCallback?.();
  };

  const disableScrolling = () => {
    setTimeout(() => {
      setHasTimerClass(true);
    }, 500);
    var x = window.scrollX;
    var y = window.scrollY;
    window.onscroll = function () {
      window.scrollTo(x, y);
    };
  };

  const enableScrolling = () => {
    setHasTimerClass(false);
    window.onscroll = function () {};
  };

  useEffect(() => {
    isSideMenuOpened ? disableScrolling() : enableScrolling();
  }, [isSideMenuOpened]);

  return (
    <div
      className={cx("header pd-20 pd-h-60", className)}
      id="header"
      //  onMouseLeave={() => {
      //   setMenuOpened(false);
      // }}
    >
      <FlexBox justifyBetween alignCenter className="header-content w-100">
        <Image
          src={Logo}
          className="curs-point w-10 logo"
          onClick={() => {
            EventManager.send(EventNames.EVENTS_NAME.WEBSITE.HEADER.HOME_CLICK);
            ChangeHistory("push", ROUTE_PATH.SAMPLES.LANDING);
          }}
        />
        <FlexBox justifyEnd alignCenter className={"w-35"}>
          {/* {window.screen.width > 968 && (
            <Button
              text={
                window.localStorage.getItem("token") ? "Dashboard" : "Login"
              }
              variant="outline"
              className="mr-r-40 pd-v-10 pd-h-20 z-1 pos-rel fs-14"
              onClick={() => {
                const endPath = window.localStorage.getItem("token")
                  ? "ACTIVITY"
                  : "SIGNUP_LOGIN";

                ChangeHistory("push", ROUTE_PATH.DASHBOARD[endPath]);
              }}
            />
          )} */}
          {/* <div
            className={cx(
              isSideMenuOpened && "hamburger-menu-opened",
              hasTimerClass && "hamburger-menu-timer",
              "curs-point hamburger-menu"
            )}
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.WEBSITE.HEADER.HAMBURGER_CLICK
              );
              hamBurgerMenuClicked();
            }}
          >
            <div />
            <div />
            <div />
          </div> */}
        </FlexBox>
        {otherDetails}
      </FlexBox>
    </div>
  );
};

export default Header;
